import { Component, inject } from '@angular/core';
import { VendorContractTypeService } from '../proxy/controlling/controllers';
import { ListService } from '@abp/ng.core';
import {
  CardComponent,
  CardBodyComponent,
  ConfirmationService,
} from '@abp/ng.theme.shared';
import {
  VendorContractTypeCreateDto,
  VendorContractTypeDto,
  VendorContractTypeExcelDownloadDto,
  VendorContractTypeUpdateDto,
} from '../proxy/controlling/dtos/vendor-contract-type';
import { VENDORCONTRACTTYPE_CONFIG, VENDORCONTRACTTYPE_FIELDS } from './vendor-contract-type.config';
import { BaseHierarchicalCrudComponent, CrudPage, GenericForm } from '@zendra/shared';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'app-vendor-contract-type',
  imports: [
    CommonModule,
    CardComponent,
    CardBodyComponent,
    CrudPage,
    GenericForm,
  ],
  providers: [ListService, VendorContractTypeService, ConfirmationService],
  templateUrl: './vendor-contract-type.html',
  styleUrl: './vendor-contract-type.scss',
})
export class VendorContractType extends BaseHierarchicalCrudComponent<
  VendorContractTypeDto,
  VendorContractTypeCreateDto,
  VendorContractTypeUpdateDto,
  VendorContractTypeExcelDownloadDto
> {
  service = inject(VendorContractTypeService);
  config = VENDORCONTRACTTYPE_CONFIG;
  fields = VENDORCONTRACTTYPE_FIELDS;

  protected prepareUpdateDto(data: any, selected: VendorContractTypeDto): VendorContractTypeUpdateDto {
    return {
      vendorId: data.vendorId,
      contractTypeId: data.contractTypeId,
      concurrencyStamp: selected.concurrencyStamp,
    };
  }

  protected getEntityName(): string {
    return 'VendorContractType';
  }
}
